import { api } from "@/services/api"

import { ApiPaymentHistoryResponse, ApiPlan, ApiSubscription } from "../types"

const BILLING_API_BASE = "/billing"

export const billingService = {
  async getCurrentSubscription(): Promise<ApiSubscription> {
    const response = await api.get<ApiSubscription>(`${BILLING_API_BASE}/subscriptions`)
    return response.data
  },

  async getAvailablePlans(): Promise<ApiPlan[]> {
    const response = await api.get<ApiPlan[]>(`${BILLING_API_BASE}/plans`)
    return response.data
  },

  getPaymentHistory: async (): Promise<ApiPaymentHistoryResponse> => {
    const response = await api.get<ApiPaymentHistoryResponse>(`${BILLING_API_BASE}/payment-history`)
    return response.data
  },
}
